import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import useAA from "../hooks/useAA";
import MainLogos from "../components/MainLogos";
import { createGlobalStyle } from "styled-components";
import { hexToRgb } from "../utils";
import { gsap } from "gsap";
import "./index.scss";

const MainPage = ({
  dataDate,
  globalData,
  artistsData,
  document,
  CUSTOM_UID,
}) => {
  const linksRef = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Animation d'apparition avec GSAP
    gsap.fromTo(
      linksRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, stagger: 0.2, duration: 1 }
    );
  }, []);

  useAA("WMF Concours:Warner Noel 2024 Advent Sweeps:Landing:Homepage");

  if (globalData) {
    const GlobalStyles = createGlobalStyle`
      :root {
        --color--blur: ${hexToRgb(globalData.blurartistcolor)};        
        --color-bg: ${globalData.backgroundcolor};
        --color--main: ${globalData.maintextcolor};
        --color-accent: ${globalData.ctacolor};
      }
    `;

    return (
      <main
        className="mainPage"
        style={{
          color: globalData.maintextcolor,
        }}
      >
        <GlobalStyles />
        <p
          className="accroche"
          dangerouslySetInnerHTML={{
            __html:
              "Le jeu concours est terminé.<br />Les gagnant.e.s seront contacté.e.s au plus vite&nbsp!",
          }}
          style={{
            color: globalData.maintextcolor,
          }}
        ></p>
        <div className="contentContainer">
          <ul className="linksContainer">
            {artistsData &&
              artistsData.map((_data, index) => {
                return (
                  <li
                    key={_data.path[0].text}
                    ref={(el) => (linksRef.current[index] = el)}
                    style={{
                      backgroundImage: `url(${
                        window.innerWidth > 768
                          ? _data.homepagepicture.url
                          : _data.homepagepicturemobile.url
                      })`,
                    }}
                    className={`linkContainer ${
                      new Date().getTime() >
                        new Date(_data.startingdate).getTime() ||
                      _data.debugmode
                        ? ""
                        : "blurred"
                    }`}
                  >
                    <div className={`blurBG card-${index + 1}`}>
                      <div
                        className=""
                        style={
                          globalData
                            ? {
                                color: globalData.maintextcolor,
                              }
                            : {}
                        }
                      >
                        {/* <p>
                          {("0" + new Date(_data.startingdate).getDate()).slice(
                            -2
                          )}
                          .{"0" + (new Date(_data.startingdate).getMonth() + 1)}
                        </p> */}
                        <h2
                          style={{
                            marginTop: "-110px",
                          }}
                        >
                          {_data.genrename[0].text}
                        </h2>
                      </div>
                      {/* {(new Date().getTime() >=
                        new Date(_data.startingdate).getTime() ||
                        _data.debugmode) && (
                        <>
                          <Link
                            // style={
                            //   globalData
                            //     ? {
                            //         color: globalData.maintextcolor,
                            //         border: `solid 1px ${globalData.maintextcolor}`,
                            //       }
                            //     : {}
                            // }
                            to={"/disquaireday/" + _data.path[0].text}
                          >
                            participer
                          </Link>
                        </>
                      )} */}
                    </div>
                  </li>
                );
              })}
          </ul>

          <Footer globalData={globalData} />
        </div>
      </main>
    );
  }
};

export default MainPage;
